<div class="patient-phone-card d-flex align-items-center">
    <mat-icon class="me-2 md-18">phone</mat-icon>
    <span class="text">
        <span>{{telNumber}}</span>
    </span>
</div>
